import { jsx as l } from "react/jsx-runtime";
import d from "react";
const m = d.memo(({
  width: e = 16,
  color: o = "#025CC2",
  height: a = 20
}) => /* @__PURE__ */ l("svg", { fill: "none", height: a, viewBox: "0 0 16 16", width: e, children: /* @__PURE__ */ l("path", { clipRule: "evenodd", d: "m11.353 2.646 2 2a.5.5 0 0 1 0 .707L11.957 6.75 9.25 4.043l1.396-1.397a.5.5 0 0 1 .707 0zm-7.707 7L8.543 4.75l2.707 2.707-4.897 4.897a.502.502 0 0 1-.195.12l-3 1a.496.496 0 0 1-.652-.399.5.5 0 0 1 .02-.233l1-3a.5.5 0 0 1 .12-.196z", fill: o, fillRule: "evenodd" }) }));
export {
  m as default
};
//# sourceMappingURL=EditIcon.es.js.map
